export const rfm_api = {
  url: 'rfmReport',
  method: 'post',
  title: '操作历史列表'
}
export const list_api = {
  url: 'operateLog',
  method: 'post',
  title: '操作历史列表'
}
export const type_api = {
  url: 'getOperatelogReporttype',
  method: 'get',
  title: '报表类型'
}
export const get_export_desc = {
  url: 'getExportDesc',
  method: 'post',
  title: '获取报表说明'
}
export const create_export_desc = {
  url: 'createExportDesc',
  method: 'post',
  title: '创建报表说明'
}



// WEBPACK FOOTER //
// ./src/views/rfm/createExportDesc/desc.js